import React from 'react';
import Banner from './components/Banner';
import EarlyBirdJP from './components/EarlyBird_JP';
import PowerSolution from './components/PowerSolution';
import TabImgs from './components/TabImgs';
import OnePicture from './components/OnePicture';
import NavPage from './components/NavPage';
import TabSwiper from './components/TabSwiper';
import CompareSelector from './components/CompareSelector';
import Screen1 from './components/Screen1';
import Screen2 from './components/Screen2';
import Screen3 from './components/Screen3';
import Screen4 from './components/Screen4';
import Screen5 from './components/Screen5';
import N from './components/N';

const JP_Product: React.FC = ({}) => {
    return (
        <>
            <Banner />
            <EarlyBirdJP endTime={new Date('2025/07/06 23:00:00 GMT+8').getTime()} />
            <PowerSolution />
            <TabImgs />
            <OnePicture />
            <NavPage />
            <Screen1 />
            <Screen5 />
            <Screen3 />
            <Screen4 />
            <Screen2 />
            <TabSwiper />
            <CompareSelector />
            <N />
        </>
    );
};
export default JP_Product;
